import { AxiosResponse } from 'axios';
import {
  IInbound,
  IInboundCount,
  IInboundItem,
  ISearchInboundReq,
  ISearchInboundRes,
} from '../interfaces/inbound';
import * as baseAdapter from './baseAdapter';
import { EInboundType } from '@/enums/EInbound';

export const searchInbounds = async (req: ISearchInboundReq) => {
  const ret = await baseAdapter.post<ISearchInboundRes>('/inbound/gets', req);
  return ret;
};

export const searchInboundItemsError = async (req: ISearchInboundReq) => {
  const ret = await baseAdapter.post<IInboundItem[]>(
    '/inbound/getInboundItemErrors',
    req,
  );
  return ret;
};

export const getInbound = async (id: number) => {
  const ret = await baseAdapter.get<IInbound>('/inbound/get/' + id);
  return ret;
};

export const countInbounds = async (type: EInboundType) => {
  const ret = await baseAdapter.get<IInboundCount>('/inbound/count/' + type);
  return ret;
};

export const updateInboundItem = async (req: Partial<IInboundItem>) => {
  const ret = await baseAdapter.put(
    '/inbound/updateInboundItem/' + req.id,
    req,
  );
  return ret;
};

export const getInboundInvoice = async () => {
  const ret = await baseAdapter.get('/inbound/getInboundInvoiceItems');
  return ret;
};

export const sendInboundInvoice = async () => {
  const ret = await baseAdapter.get('/inbound/sendInboundInvoiceItems');
  return ret;
};

export const calculateCost = async () => {
  const ret = await baseAdapter.post('/declearation/calculateCost', '');
  return ret;
};

export const syncDelievry = async () => {
  const ret = await baseAdapter.post('/inbound/syncDelivery', {
    search: 'string',
  });
  return ret;
};

export const addInbound = async (
  data: Partial<IInbound>,
): Promise<AxiosResponse<IInbound>> => {
  const ret = await baseAdapter.post<IInbound>('/inbound/create', data);
  return ret;
};

export const updateInbound = async (
  data: Partial<IInbound>,
): Promise<AxiosResponse<IInbound>> => {
  const ret = await baseAdapter.put('/inbound/update/' + data.id, data);
  return ret;
};

export const updateInboundStatus = async (
  id: number,
): Promise<AxiosResponse<IInbound>> => {
  const ret = await baseAdapter.put('/inbound/approve/' + id, {});
  return ret;
};

export const patchInboundItemUpdate = async (data: Partial<IInboundItem>) => {
  const ret = await baseAdapter.patch(
    `/inbound/patchItemUpdate/${data.id}`,
    data,
  );
  return ret;
};
